const NbspRule = ({ item }) => {
  if (item.teaserTitle) {
    return {
      item: {
        ...item,
        teaserTitle: item.teaserTitle.replace(/&nbsp;/g, '\u00a0')
      }
    }
  }
  return null
}

export default NbspRule